<h1 mat-dialog-title>{{ title }}</h1>
<hr>

<form id="form" autocomplete="off" [formGroup]="form" (ngSubmit)="enviar()">
  <mat-dialog-content>
    <div class="row">
      <div class="col-12 col-sm-4 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Razón Social</mat-label>
          <input matInput formControlName="nombre" placeholder="Razón Social"
            (blur)="form.controls['nombre'].markAsTouched()" uppercase alphanumericOnly maxlength="50">
          <mat-error *ngIf="isValidField('nombre')">
            {{ getFieldError('nombre') }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-sm-4 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>RFC</mat-label>
          <input matInput formControlName="rfc" placeholder="RFC"
            (blur)="form.controls['rfc'].markAsTouched()" uppercase alphanumericOnly maxlength="13">
          <mat-error *ngIf="isValidField('rfc')">
            {{ getFieldError('rfc') }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-12 col-sm-4 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Teléfono</mat-label>
          <input matInput formControlName="telefono" placeholder="Teléfono"
            (blur)="form.controls['telefono'].markAsTouched()"  phoneMask>
          <mat-error *ngIf="isValidField('telefono')">
            {{ getFieldError('telefono') }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
        <div class="col-12 col-sm-6 col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fax</mat-label>
            <input matInput formControlName="fax" placeholder="Fax"
              (blur)="form.controls['fax'].markAsTouched()" phoneMask>
            <mat-error *ngIf="isValidField('fax')">
              {{ getFieldError('fax') }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" class="m-1" type="submit" *ngIf="mostrarBoton">
      <i class="fa fa-save"></i> Guardar
    </button>
    <button mat-raised-button color="warn" class="m-1" mat-dialog-close>
      <i class="fa fa-remove fa-solid"></i> Cancelar
    </button>
  </mat-dialog-actions>
</form>